import {Component, OnInit, ViewChild} from '@angular/core';
import {AccountService} from '../../Services/account.service';
import {AuthenticationService} from '../../Services/authentification/services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Token} from "../../Services/authentification/models/token";
import {OrderService} from "../../Services/order.service";
import {StorageService} from "../../Services/storage.service";

@Component({
    selector: 'app-header-user-profile-drop-down',
    templateUrl: './header-user-profile-drop-down.component.html',
    styleUrls: ['./header-user-profile-drop-down.component.scss'],
    standalone: false
})
export class HeaderUserProfileDropDownComponent implements OnInit {


  register = false;
  paswrd = false;
  login = true;
  username?: string;
  isConnected?: boolean;

  nbCurrentOrders:number = 0;
  showOrderBadge = false;

  constructor(private storage: StorageService,
              private router: Router,
              private orderService: OrderService,
              private route: ActivatedRoute,
              public accountService: AccountService,
              private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.accountService.accountSubject.subscribe(client => {
      if (client) {
        this.username = client.firstname!;
        this.isConnected = true;
      } else {
        this.username = '';
        this.isConnected = false;
      }
    });

    this.orderService.orderSubject.subscribe( (orders:any) => {
      if(orders && orders[0] != null) {
        this.nbCurrentOrders = orders.content.filter((o: any) => o.state === 'CREATED' || o.state === 'NOT_PAID').length
        this.nbCurrentOrders = 0;
      }
    });


    //OAUTH2, retrieve token from route then proceed to authentication
    this.route.queryParams.subscribe(
      params => {
        const accessToken = params['token'];
        const error = params['error'];
        // console.log('get token     ' + token);
        if (accessToken) {
          const token = new Token(accessToken, '', 0, '', '');
          this.storage.setItem('currentToken', JSON.stringify(token));
          this.authenticationService.currentTokenSubject.next(token);
        
          this.router.navigate([], {
            queryParams: {} // Use an empty object to clear query parameters
          });
        }
        
        if (error) {
          this.router.navigate([], {
            queryParams: null
          });
        
        }
      }
    );


  }


  onLogOut(){
    this.authenticationService.logout();
    this.router.navigateByUrl('/');
  }

  showSignIn(){
    this.login = true; this.register = false; this.paswrd = false;
  }
  showSignUp() {
    this.login = false; this.register = true; this.paswrd = false;
  }
  showForgotPwd() {
    this.login = false; this.register = false; this.paswrd = true;
  }

}
